// @flow

import InlineLink from './inline-link'

export default InlineLink
